<script>
import Mobile from "./Mobile";
import Desktop from "./Desktop";

export default {
  props: {
    orders: {
      type: Array,
      required: true
    }
  },
  components: {
    Mobile,
    Desktop
  },
  data() {
    return {
      width: 0,
      height: 0
    };
  },
  methods: {
    handleResize() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<template>
  <section>
    <mobile v-if="width <= 992" :orders="orders" />
    <desktop v-else :orders="orders" />
  </section>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Cycle/Orders/Index.vue